import useSWR from "swr";

export function useChainlinkDesign(id) {
  const { data, error, isLoading, mutate } = useSWR(
    `/team/chainlinkDesign/${id}`,
  );

  return {
    design: data,
    isLoading,
    error,
    mutate,
  };
}
